module.exports = __webpack_public_path__ + "img/ИФ-1(А)-005-m.6c17c7c0.png";